export default __webpack_public_path__ + "static/ENG_Step_2-3aca94782e13c5e565b277017c9d0adc.svg";